export default __webpack_public_path__ + "static/media/biketourmap.319a393b.jpg";